import { type RovoInstrumentedError } from './httpUtils';

const generateTraceId = () =>
	`${Date.now().toString(16)}-${Math.floor(Math.random() * 1e4).toString(16)}`;

export class RovoChatStreamTimeoutError extends Error implements RovoInstrumentedError {
	errorAttributes: RovoInstrumentedError['errorAttributes'];

	constructor(
		message: string,
		params: {
			traceId: string | undefined;
			requestId?: string | undefined;
		},
	) {
		super(message);
		this.name = this.constructor.name;
		this.errorAttributes = {
			requestId: params.requestId,
			traceId: params.traceId ?? params.requestId ?? `RovoChatStreamTimeout-${generateTraceId()}`,
		};
	}
}
